// Modelo Elementos para administrador.
export default class Element {
    id=""
    name=""
    description=""
    type=""
}



// WEBPACK FOOTER //
// ./src/model/Element.js